import { initialize } from './statsig'
import locator from '@/service-locator'

/**
 * Initialize Statsig with country detection
 * Handles both scenarios:
 * 1. Country detection completes before Statsig initialization
 * 2. Statsig initializes before country detection completes
 */
export const initializeStatsigWithCountry = async () => {
  const statsigKey =
    process.env.VUE_APP_STATSIG_CLIENT_KEY || locator.config.statsigKey

  if (!statsigKey) {
    console.warn('Statsig client key not found, skipping initialization')
    return
  }

  // Base configuration
  const baseConfig = {
    sdkKey: statsigKey,
    user: {},
    sdkOptions: {
      environment: { tier: process.env.VUE_APP_STATSIG_CLIENT_ENV },
    },
  }

  // Initialize Statsig immediately with default country
  await initialize(baseConfig.sdkKey, baseConfig.user, baseConfig.sdkOptions)
}
